import * as React from "react";

function SvgAutopilotHq(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 34 34"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        d="M17 33C8.2 33 1 25.8 1 17S8.2 1 17 1s16 7.2 16 16-7.2 16-16 16zM9.4 18.9l2.4 3.6h9.7l2.4-3.6H9.4zM7 13l2.4 3.7h14.5l2.4-3.7H7z"
        fill="#12d1ae"
      />
    </svg>
  );
}

export default React.forwardRef(SvgAutopilotHq);
